module.exports = __webpack_public_path__ + "img/atm_m_bank_l_bank.6ae50d96.png";